// extracted by mini-css-extract-plugin
module.exports = {"app":"uv_rDZ","main":"wfyH2Q"};